import styled from "styled-components";
import DesignConstants from "../../constants/DesignConstants";

export const OnboardingProgressWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.XS};
`;

export const OnboardingCollapsibleSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.XS};
`;

export const OnboardingStepsContainer = styled.ul`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.XS};
    padding: 0;
    margin: 0;
`;

export const OnboardingStepListItem = styled.li`
    list-style: none;
`;

export const ExpandableHeaderContainer = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    padding: 0;
    background: none;

    &:hover {
        opacity: ${DesignConstants.OPACITY.SIX};
    }
`;

export const ExpandableHeader = styled.h2`
    color: ${DesignConstants.COLORS.DARK_GREY};
    font-size: ${DesignConstants.FONT_SIZES.M};
    font-weight: ${DesignConstants.FONT_WEIGHTS.NORMAL};
`;

export const ChevronIcon = styled.div<{ isExpanded: boolean }>`
    transition: transform 0.2s ease;
    transform: ${(props) => (props.isExpanded ? "rotate(90deg)" : "rotate(0deg)")};
    display: flex;
    align-items: center;
`;
